import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VerifyUrlAssigned } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class VerifyUrlAssignedService extends BaseApiService<VerifyUrlAssigned> {
  get cacheKey(): StorageKey {
    return StorageKey.verifyUrlAssignedCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/urlassigned`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return VerifyUrlAssigned.unparse(obj);
  }

  protected parse(obj) {
    return VerifyUrlAssigned.parse(obj);
  }
}
